(ns common.schema.entities.decision-advisory-board
  (:require
   [common.schema.schema-utils :as su]
   [common.schema.entities.common :as common]
   [common.schema.entities.decision :as decision]))

(def schema
  (concat
   decision/schema))

(def required-fields
  #{:decision/date
    :decision/meeting-type})
